export default {"src":"/_next/static/image/public/images/ic_plus_white.fff98c719a33c20ea5a95cd991282b83.svg","height":17,"width":17};